import { gql } from "@apollo/client";

export const START_IMPERSONATION_SESSION = gql`
  mutation startImpersonationSession($targetUserId: ID!) {
    startImpersonationSession(targetUserId: $targetUserId) {
      sessionId
      startedAt
      target {
        id
        firstName
        lastName
        email
        role
        companyId
        companyName
        features
      }
    }
  }
`;

export const END_IMPERSONATION_SESSION = gql`
  mutation endImpersonationSession($sessionId: ID!) {
    endImpersonationSession(sessionId: $sessionId) {
      success
    }
  }
`;
